import { matchIsMobileMode, ReactNativeMessages } from '@scouts/helpers'

import { useProfile } from '@/store/profile'

import { useSelfEmployedPlatformVisibility } from './use-self-employed-platform-visibility'

// @TODO: Move hook to scouts-helpers and accept data as an argument
export const useUpdateReactNative = () => {
    const profile = useProfile()
    const { shouldDisplaySelfEmployedPlatform } = useSelfEmployedPlatformVisibility()

    const updateReactNative = () => {
        matchIsMobileMode(
            () => {
                ReactNativeMessages.profile({
                    ...profile,
                    shouldDisplaySelfEmployedPlatform,
                })
            },
            () => {}
        )
    }

    return { updateReactNative }
}
